import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { randomColor } from 'utils'
import { Navigation, Responsive, Templates, Search } from 'ui'
import { truncate } from 'utils'
import { usePaginatedAdminSearch } from './usePaginatedAdminSearch'
import { SecondaryDrawerPortal } from '../../AppNavigator/SecondaryDrawerPortal'

const { Navigator } = Templates

interface IUserProfileDetailParams {
  id: string
}

export const UserProfileNavigationDrawer: React.FC = () => {
  const { drawerActive, drawerCompact } = useContext(
    Responsive.DrawerManagerContext
  )
  const params = useParams<{ id: string }>()
  const id = params.id ?? ''
  const {
    currentPage,
    error,
    loading,
    profiles,
    handlePageClick,
    pageCount,
    queryString,
    tempQueryString,
    facets,
    toggleFacet,
    appliedFacets,
    tempFacets,
    setTempSearchQuery,
    locationSearch,
    humanizedAppliedFacets,
  } = usePaginatedAdminSearch()
  const renderContentItem = (profile: any) => {
    return (
      <Navigator.ContentItem
        key={profile?.id}
        label={`${profile?.name}`}
        maxInitials={2}
        color={profile?.color || randomColor()}
        imageUrl={profile?.avatarUrl as string}
        content={truncate(profile?.about || '', 38)}
        to={`/admin/profiles/show/${profile?.id}${locationSearch}`}
        active={id === profile?.id}
      />
    )
  }

  const contentItems = profiles?.map((p) => renderContentItem(p as any))
  const handleClearFilter = (id: string) => {
    toggleFacet(id, 'remove')
  }

  return (
    <SecondaryDrawerPortal>
      <Navigator.Drawer
        hasSibling={drawerActive}
        hasCompactSibling={drawerCompact}
        theme="secondary"
      >
        <React.Fragment>
          <Navigator.Generic className="py-4">
            <Search.SearchControls
              facets={humanizedAppliedFacets}
              queryString={tempQueryString ?? ''}
              onQuery={setTempSearchQuery}
              onRemoveFacet={handleClearFilter}
            />
          </Navigator.Generic>
          {contentItems}
          {loading ? null : (
            <Navigation.SimplePaginationBar
              onPageClick={handlePageClick({ historyPush: true })}
              currentPage={currentPage ?? 0}
              pageCount={pageCount ?? 0}
            />
          )}
        </React.Fragment>
      </Navigator.Drawer>
    </SecondaryDrawerPortal>
  )
}
